import { Tooltip } from "antd";
import dayjs from "dayjs";

export const TabTitle = (newTitle) => {
  return (document.title = newTitle);
};

export const getLoggedInUser = () => {
  const loginUser = localStorage.getItem("c2p") || "";
  const user = loginUser ? JSON.parse(loginUser) : { user: null };
  return {
    ...user,
    loggedIn: loginUser !== "",
  };
};

export const getLocalToken = () => {
  const user = JSON.parse(localStorage.getItem("c2p"));
  const authToken = user?.accessToken;
  if (authToken !== null && authToken !== "") {
    return `Bearer ${authToken}`;
  } else {
    return "";
  }
};

export const updateQuery = (location, queries) => {
  const newParams = new URLSearchParams(location.search);
  Object.entries(queries).forEach(([key, val]) => {
    newParams.set(key, val);
  });

  const newUrl = `${location.pathname}?${newParams.toString()}`;
  window.history.pushState({}, "", newUrl);
};

//get years list
export const getYearList = () => {
  const startYear = 2014;
  const currentYear = dayjs().year();
  const years = [];

  for (let year = startYear; year <= currentYear + 5; year++) {
    years.push(year);
  }

  return years.map((year) => ({ label: year, value: year }));
};

//get months list
export const getMonthList = () => {
  const months = [];

  for (let i = 0; i < 12; i++) {
    months.push(dayjs().month(i).format("MMMM"));
  }

  return months.map((month) => ({ label: month, value: month.toLowerCase() }));
};

//get current year and month
export const getCurrentYearAndMonth = () => {
  const month = dayjs().format("MMMM").toLowerCase();
  const year = dayjs().year();

  return { month, year };
};

// cell renderer for table
export const cellRenderer = (
  text,
  classes,
  nullvalue = "-",
  truncate = false,
) => {
  return truncate ? (
    <Tooltip title={text || nullvalue} classNames={{ root: "!text-xs" }}>
      <p
        className={`p-0 m-0 font-medium truncate text-2xs ${classes} text-text-tint`}
      >
        {text || nullvalue}
      </p>
    </Tooltip>
  ) : (
    <p className={`p-0 m-0 font-medium text-2xs ${classes} text-text-tint`}>
      {text || nullvalue}
    </p>
  );
};

// header renderer for table
export const headerCellRenderer = (
  text,
  classes,
  nullvalue = "-",
  truncate = false,
) => {
  return truncate ? (
    <Tooltip title={text || nullvalue} classNames={{ root: "!text-xs" }}>
      <div
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        className={`text-2xs font-semibold ${classes} !truncate text-secondary-main`}
      >
        {text || nullvalue}
      </div>
    </Tooltip>
  ) : (
    <label className={`font-semibold text-2xs ${classes} text-secondary-main`}>
      {text || nullvalue}
    </label>
  );
};

//to title case
export const toTitleCase = (text) => {
  return text
    ? text
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : "";
};

//date to show
export const getDateToDisplay = (date) => {
  return date ? dayjs(date).format("DD MMMM, YYYY") : null;
};

//mapping the data to format date
export const getCorrectedDateFormatKeys = (data, keys) => {
  return data.map((item) => {
    const formattedKeys = keys.reduce((acc, key) => {
      acc[key] = dayjs(item[key]).format("YYYY-MM-DD");
      return acc;
    }, {});

    return {
      ...item,
      ...formattedKeys,
    };
  });
};

export const cleanFileName = (filename) => {
  // Remove the extension
  let nameWithoutExt = filename.replace(/\.[^/.]+$/, "");

  // Remove the word 'raw' (case insensitive)
  let cleanedName = nameWithoutExt.replace(/raw/gi, "").trim();

  return `${cleanedName}_cleaned_file.xlsx`;
};

//strip html from string
export const stripHtml = (htmlString) => {
  const div = document.createElement("div");
  div.innerHTML = htmlString;
  return div.textContent || div.innerText || "";
};

//get previous third month
export const getPrevThirdMonth = () => {
  const date = dayjs().subtract(3, "month");

  return {
    year: date.year(),
    month: date.format("MMMM"),
  };
};

//get curretn month and year
export const getCurrentMonth = () => {
  const date = dayjs();

  return {
    year: date.year(),
    month: date.format("MMMM"),
  };
};

//smart round
export const smartRound = (value) => {
  if (value >= 0 && value < 1) {
    return Number(value).toFixed(2);
  }
  return Math.round(value);
};
